var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 45.625C16.4141 45.625 9.03125 41.4062 4.98828 34.375C0.945312 27.4316 0.945312 18.9062 4.98828 11.875C9.03125 4.93164 16.4141 0.625 24.5 0.625C32.498 0.625 39.8809 4.93164 43.9238 11.875C47.9668 18.9062 47.9668 27.4316 43.9238 34.375C39.8809 41.4062 32.498 45.625 24.5 45.625ZM34.4316 18.9941H34.3438C35.2227 18.2031 35.2227 16.8848 34.3438 16.0059C33.5527 15.2148 32.2344 15.2148 31.4434 16.0059L21.6875 25.8496L17.5566 21.7188C16.6777 20.8398 15.3594 20.8398 14.5684 21.7188C13.6895 22.5098 13.6895 23.8281 14.5684 24.6191L20.1934 30.2441C20.9844 31.123 22.3027 31.123 23.1816 30.2441L34.4316 18.9941Z",
    fill: "#009BDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplete);
export default __webpack_public_path__ + "static/media/icon_complete.75c38d15289274603ca89b03429aa593.svg";
export { ForwardRef as ReactComponent };